module.exports = __webpack_public_path__ + "static/media/ic-settings.c92ae260.svg";